<script setup lang="ts">
import { useClipboard } from '@vueuse/core';
import { useI18n } from 'vue-i18n';
import { useConfirm } from 'primevue/useconfirm';
import type { FieldSchema } from '../../../types';

const props = defineProps<{
  field: FieldSchema;
  model: any;
}>();

const { t } = useI18n();
const { copy, copied } = useClipboard({ source: props.model, legacy: true });
const confirm = useConfirm();

function onConfirmSearch(event: any) {
  confirm.require({
    group: 'searchAhaa',
    target: event.currentTarget,
    icon: 'pi pi-search text-sky-500',
    acceptIcon: 'pi pi-external-link',
    rejectClass: 'p-button-secondary p-button-sm text-xs',
    acceptClass: 'p-button-sm text-xs af-button-success',
    rejectLabel: t('common.cancel'),
    acceptLabel: t('common.open'),
    accept: () => onSearch(),
  });
}

function onSearch() {
  window.open(
    'https://www.aaha.org/for-veterinary-professionals/microchip-registry-lookup-tool-aaha-find-your-pets-microchip-registry/?microchip_id=' +
      props.model +
      '&AllowNonAlphaNumberic=0/',
    '_blank'
  );
}
</script>

<template>
  <div class="flex flex-wrap items-center gap-7">
    <Button
      outlined
      class="af-button group/search !min-h-0 border-none !p-0 !py-0.5 !pr-2 !text-xs"
      icon="pi pi-search"
      severity="info"
      pt:icon="text-xs"
      :label="$t('components.forms.aaha.label')"
      @click="onConfirmSearch"
    />

    <div class="flex items-center gap-1">
      <i
        :class="[
          'w-fit cursor-pointer text-sm  hover:text-brand-500',
          !copied ? 'pi pi-copy text-gray-500' : 'pi pi-check text-brand-500',
        ]"
        @click="copy(model)"
      />

      <p
        v-if="copied"
        class="text-xs text-gray-500"
      >
        {{ $t('common.copied') }}
      </p>
    </div>
  </div>

  <aside>
    <ConfirmPopup group="searchAhaa">
      <template #message>
        <div class="flex flex-col items-center justify-center gap-3 p-4 text-center">
          <i class="pi pi-search text-3xl text-sky-500"></i>

          <div>
            <h2 class="font-medium">{{ t('components.forms.aaha.aahaHeader') }}</h2>

            <p class="text-sm">{{ t('components.forms.aaha.aahaMessage') }}</p>
          </div>
        </div>
      </template>
    </ConfirmPopup>
  </aside>
</template>
